import router from '@/site/router'
import moment from 'moment'

export function generateProductSchema(product, variant) {
	let productUrlPath = router.resolve({
		name: 'product',
		params: { id: product.id, urlName: product.urlName },
	}).href

	let name = [product.name]
	if (variant.attrs?.length) {
		let variantName = variant.attrs.map((attr) => attr.v).join(' - ')
		name.push(`(${variantName})`)
	}
	name = name.join(' ')

	let data = {
		'@context': 'http://schema.org',
		'@type': 'Product',
		name,
		category: product.categories.map((c) => c.name).join(' > '),
		sku: variant.sku,
		url: `${window.location.origin}${productUrlPath}`,
		offers: {
			'@type': 'Offer',
			url: `${window.location.origin}${productUrlPath}`,
			priceCurrency: variant.pvPrice.priceConfig.currency.iso,
			priceValidUntil: moment().add(10, 'days').format('YYYY-MM-DD'),
			price: variant.pvPrice.price.toFixed(2),
			availability: `https://schema.org/${variant.stock.availability}`,
			seller: { '@type': 'Organization', name: window.location.host },
		},
	}

	let image = product.mainImage || product.images[0]
	if (image) {
		data.image = `${window.location.origin}${image.mediumUrl}`
	}

	if (product.brand) {
		data.brand = {
			'@type': 'Brand',
			name: product.brand.name,
		}
	}

	if (variant.ean) {
		data.gtin = variant.ean
	}

	data.description = product.info?.description || product.name

	return data
}
